// extracted by mini-css-extract-plugin
export default {"segmentedBar":"styles_segmentedBar__lRHy7","segment":"styles_segment__-02T7"};